const setRefreshModules = (state, refresh) => {
  if (!refresh) return
  if (!state.modules) state.modules = {}
  Object.keys(refresh).forEach(key => {
    const date = getDateTimestampValue(refresh[key])
    if (state.modules[key] !== date) {
      //Update only keys changed
      state.modules[key] = date
    }
  })
}

const getDateTimestampValue = data => {
  return data.toDate ? data.toDate().getTime() : data
}

const setListener = (state, listener) => {
  if (state.listener) {
    state.listener()
  }
  state.listener = listener
}

const clearListener = state => {
  if (state.listener) {
    state.listener()
  }
  state.listener = null
}

export default {
  setRefreshModules,
  setListener,
  clearListener
}
